import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'confirmation-dialog-component',
    styleUrls: ['confirmation.dialogcomponent.css'],
    templateUrl: 'confirmation.dialogcomponent.html'
})
export class ConfirmationDialogComponent implements OnInit {
    title: string;
    message: string;
    iconcolor: string;
    iconname: string;    
    oktext: string;
    canceltext: string;
    showIcon: boolean;

    constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) data: _ConfirmationDialogOptions) {
        this.title = data.TitleText || 'Confirmation Requested...';
        this.message = data.MessageText || '';
        this.iconcolor = data.IconColor || 'primary';
        this.iconname = data.IconName || 'help';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.showIcon = (data.ShowIcon != null ? data.ShowIcon : true);
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    ngOnInit() {

    }

    OKHandler() {
        this.dialogRef.close(true);
    }
}

// #region Custom Classes

    export class _ConfirmationDialogOptions {
        TitleText?: string;
        MessageText?: string;
        OKText?: string;
        CancelText?: string;
        IconColor?: string;
        IconName?: string;
        ShowIcon?: boolean;
        height?: string;
        width?: string;
    }

// #endregion


// WEBPACK FOOTER //
// ./src/services/dialogs/confirmation/confirmation.dialogcomponent.ts